import script from "./SideTabulationChat.vue?vue&type=script&setup=true&lang=js"
export * from "./SideTabulationChat.vue?vue&type=script&setup=true&lang=js"

import "./SideTabulationChat.vue?vue&type=style&index=0&id=f15d42a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f15d42a4"]])

export default __exports__
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTime from 'quasar/src/components/time/QTime.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QField from 'quasar/src/components/field/QField.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerHourglass,QIcon,QForm,QInput,QSelect,QOptionGroup,QPopupProxy,QDate,QBtn,QTime,QSeparator,QField,QRadio});qInstall(script, 'directives', {ClosePopup});
